import { ActiveMove, ExtendedMove } from "@/types/types"
import Move from "./Move"
import clsx from "clsx"

type LineProps = {
  index: number
  moves: ExtendedMove[]
  position: ActiveMove
  depth: number
  active: boolean
  activeMoveIndex: number
  onMoveClick: (position: ActiveMove) => void
  hideFuture?: boolean
}

const Line = ({
  index,
  moves,
  position,
  depth,
  active,
  activeMoveIndex,
  onMoveClick,
  hideFuture = false,
}: LineProps) => {
  const isSubline = depth > 0
  const isFirstLine = index === 0 && depth === 0

  return (
    <div
      className={clsx({
        "h-[42px]": isSubline,
      })}
    >
      <div
        className={clsx(
          "flex items-start space-x-1.5",
          isSubline ? "absolute mt-1.5 pr-6 pb-6" : "relative"
        )}
      >
        {isSubline && (
          <div className="relative h-9 w-20 overflow-hidden">
            <div
              className="absolute -top-4 -right-9 h-full w-full rounded-xl border-2 border-gray-300"
              aria-hidden="true"
            />
          </div>
        )}
        {moves.map((move, i) => {
          const isFirstInGroup = i % 2 === 0
          const groupNumber = Math.ceil((i + 1) / 2)
          const isFuture = activeMoveIndex == undefined || i > activeMoveIndex

          return (
            <div
              key={i}
              className={clsx("relative", {
                "mt-4": isFirstLine && isFirstInGroup,
                "pt-4": isFirstLine && !isFirstInGroup,
              })}
            >
              {isFirstLine && isFirstInGroup && (
                <div className="absolute -top-6 text-sm font-medium text-gray-500">
                  {groupNumber}.
                </div>
              )}
              <Move
                move={move}
                active={active && activeMoveIndex === i}
                position={[...position, [index, i]]}
                widthClassName="w-20"
                onClick={onMoveClick}
                hidden={hideFuture && isFuture}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Line
